var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_core.js
// module id = 99
// module chunks = 0